import React from 'react';
import { object, bool, string } from 'prop-types';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { size } from 'lodash';
import { FlexContainer } from 'base-components';
import ConditionalRender from 'app-components/shared/ConditionalRender';
import SelectButton from './SelectButton';
import SelectOptions from './SelectOptions';
import SelectIcon from './SelectIcon';
import { GRAY_DARK } from '../../../../utils/colors';

const Select = styled(FlexContainer)`
    cursor: pointer;
    position: relative;
    border: ${({ error, borderColor }) => `solid 1px ${error ? '#d60101' : borderColor || GRAY_DARK}`};
    min-height: 34px;
    height: 34px;
    border-radius: 4px;
    flex-wrap: wrap;
    font-size: 12px;
    color: #333333;
    background-color: #FFFFFF;

    &:hover {
        border: 1px solid #4cb358;
    }

    ${({ multiple }) => `
        height: auto;
    `}

    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 60%;
    `}
`;

const SelectDisplay = ({ optionsUp, placeholderAllSelected, position, error, context: SelectContext, borderColor }) => (
    <SelectContext.Consumer>
        {({ label, opened, isMultiple, toggleOptions, disabled, options, fromUserSelect, loadingFilterUser, filterBy }) => (
            <Select disabled={disabled} multiple={isMultiple} error={error} borderColor={borderColor}> {/**  toggleOptions(): abre el select de options */}
                <SelectButton placeholderAllSelected={placeholderAllSelected} label={label} context={SelectContext} />
                {!fromUserSelect && <SelectIcon className={`icon-ic-fat-arrow-${classNames({ 'down': !opened, 'up': opened })}`} color='#4cb358' />}
                <ConditionalRender condition={opened && !(fromUserSelect && !size(filterBy) > 3)}>
                    <SelectOptions position={position} optionsUp={optionsUp} placeholderAllSelected={placeholderAllSelected} context={SelectContext} fromUserSelect={fromUserSelect} />
                </ConditionalRender>
            </Select>
        )}
    </SelectContext.Consumer>
);

SelectDisplay.propTypes = {
    optionsUp: bool,
    position: object,
    placeholderAllSelected: bool,
    error: bool,
    context: object,
    borderColor: string
};

export default SelectDisplay;
